import _regeneratorRuntime from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { verifyPhone } from "../../../../api/requests";
import Router from 'next/router';
export var ValidateInputs = function ValidateInputs(input, setError) {
  var validated = true;

  if (input.CellPhoneNum.length !== 11) {
    // console.log("input.CellPhoneNum.length", input.CellPhoneNum.length)
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        CellPhoneNum: "Mobile phone number must be 11 digits long",
        CellPhoneNumFa: "شماره تلفن همراه باید ۱۱رقم باشد"
      });
    });
    validated = false;
  }

  if (isNaN(Number(input.CellPhoneNum))) {
    // console.log("typeof(input.CellPhoneNum) from inside: ", typeof (input.CellPhoneNum))
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        CellPhoneNum: "Mobile phone number must be only numbers",
        CellPhoneNumFa: "تلفن همراه باید فقط عدد باشد"
      });
    });
    validated = false;
  }

  if (!input.CellPhoneNum) {
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        CellPhoneNum: "Mobile phone number field must be filled",
        CellPhoneNumFa: "پرکردن فیلد تلفن همراه الزامیست"
      });
    });
    validated = false;
  } // console.log("validated: ", validated);


  return validated;
};
export var handleSubmitPhone = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, setError, setServerResponse, input, setLoading, setTitle, setTitleFa, args) {
    var CellPhoneNum, validated, res, err;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setError(null);
            setServerResponse(null); // console.log("input: ", input)

            CellPhoneNum = input.CellPhoneNum;
            validated = ValidateInputs(input, setError);

            if (!validated) {
              _context.next = 29;
              break;
            }

            setLoading(true);
            setTitle("Please wait");
            setTitleFa("لطفا صبر کنید"); // console.log("config: ", config);

            _context.prev = 9;
            _context.next = 12;
            return verifyPhone(CellPhoneNum);

          case 12:
            res = _context.sent;
            // console.log("new LOGIN resssss", res)
            // setServerResponse(res.data);
            setTitle("");
            setTitleFa("");
            Router.push({
              pathname: '/verifyCode',
              query: args
            });
            localStorage.setItem('Counter', res.data.Counter);
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('CellPhoneNum', CellPhoneNum);
            setLoading(false);
            _context.next = 29;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](9);
            console.log("error", {
              error: _context.t0
            });

            if (_context.t0 && _context.t0.response && _context.t0.response.status) {
              err = _context.t0.response.status; // console.log("err",error.response.data.message)
              // console.log("error", {error})
            }

            console.log("err", err);

            if (err == 400) {
              // setServerResponse(error.response.data.message);
              setServerResponse({
                en: "Oops, There was a problem, Please try again.",
                fa: "ارتباط با سرور برقرار نشد، لطفا دوباره سعی کنید."
              });
            } else if (err) {
              setServerResponse({
                en: "Please contact us if you see this error",
                fa: "لطفا در صورت مشاهده این خطا با ما تماس بگیرید"
              });
            } // console.log("err", {err});


            setLoading(false);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 22]]);
  }));

  return function handleSubmitPhone(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();